<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div class="tbl-scroll-host">
      <el-table :data="tableData" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
        ref="table" class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="Name" label="故障类型名称" min-width="100"></el-table-column>
        <el-table-column prop="Code" label="编码" width="100"></el-table-column>
        <el-table-column prop="Sort" label="排序" width="70"></el-table-column>
        <el-table-column label="是否默认" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsDefault ? 'success' : 'info'" size="small">
              {{ scope.row.IsDefault ? '默认' : '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="RepairerTeacherNames" label="绑定维修师傅" min-width="150"></el-table-column>
        <el-table-column prop="DepartmentName" label="所属学校" min-width="120"></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" width="180"></el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="pageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--新增/编辑弹窗-->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" destroy-on-close
        width="550px">
        <el-form :model="form" label-width="120px" :rules="formRules" ref="form">

          <el-form-item label="故障类型名称" prop="Name">
            <el-input v-model="form.Name" placeholder="如：电教、水电、其他" auto-complete="off"
              @input="onNameInput"></el-input>
          </el-form-item>

          <el-form-item label="编码">
            <el-input v-model="form.Code" disabled placeholder="根据名称自动生成"></el-input>
            <div style="margin-top: 6px; color: #909399; font-size: 12px;">
              {{ isEdit ? '编码创建后不可修改' : '保存时根据名称自动生成' }}
            </div>
          </el-form-item>

          <el-form-item label="排序号" prop="Sort">
            <el-input-number v-model="form.Sort" :min="1" style="width: 120px;"></el-input-number>
          </el-form-item>

          <el-form-item label="是否默认">
            <el-switch v-model="form.IsDefault" active-text="是" inactive-text="否"></el-switch>
            <span style="margin-left: 8px; color: #909399; font-size: 12px;">同部门只能有一个默认类型</span>
          </el-form-item>

          <el-form-item label="绑定维修师傅" prop="RepairerTeacherIdList">
            <el-select v-model="form.RepairerTeacherIdList" multiple filterable
              placeholder="请选择维修师傅（可多选）" style="width: 100%;">
              <el-option v-for="user in teacherList" :key="user.Id" :label="user.TeacherName"
                :value="user.Id"></el-option>
            </el-select>
            <div style="margin-top: 6px; color: #909399; font-size: 12px;">
              绑定后报修审批通过，系统将把工单派给以上师傅
            </div>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">保存</el-button>
        </div>
      </el-dialog>

    </section>
  </section>
</template>

<script>
import { getRepairFaultTypeList, addRepairFaultType, editRepairFaultType, deleteRepairFaultType, initRepairFaultTypeDefaults } from '../../api/modules/repair';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      searchList: [{ label: '名称', key: 'name' }],
      filters: {},
      tableData: [],
      total: 0,
      pageSize: 10,
      page: 1,
      listLoading: false,
      buttonList: [],
      currentRow: null,
      DepartmentId: 0,
      teacherList: [],

      dialogVisible: false,
      dialogTitle: '新增故障类型',
      submitLoading: false,
      isEdit: false,

      form: {
        Id: 0,
        DepartmentId: 0,
        Name: '',
        Code: '',
        Sort: 1,
        IsDefault: false,
        RepairerTeacherIdList: []
      },
      formRules: {
        Name: [{ required: true, message: '请输入故障类型名称', trigger: 'blur' }],
        Sort: [{ required: true, message: '请输入排序号', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleQuery() {
      const para = {
        departmentId: this.DepartmentId,
        ...this.filters,
        page: this.page,
        intPageSize: this.pageSize
      };
      this.listLoading = true;
      getRepairFaultTypeList(para).then(res => {
        this.listLoading = false;
        if (res.data && res.data.success) {
          const data = res.data.response;
          if (Array.isArray(data)) {
            this.tableData = data;
            this.total = data.length;
          } else if (data && data.data) {
            this.tableData = data.data;
            this.total = data.dataCount || data.data.length;
          }
        }
      }).catch(() => { this.listLoading = false; });
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.handleQuery();
      this.loadTeachers(data.value);
    },

    loadTeachers(departmentId) {
      return getTeacherMasterList({ page: 1, intPageSize: 9999, departmentId }).then(res => {
        if (res.data && res.data.success) {
          const raw = res.data.response.data || res.data.response || [];
          this.teacherList = raw.map(u => ({ ...u, Id: String(u.Id) }));
        } else {
          this.teacherList = [];
        }
      });
    },

    parseIdList(raw) {
      if (!raw) return [];
      return String(raw).split(/[|/,，、]/).map(s => s.trim()).filter(Boolean);
    },

    /** 已绑定的师傅不在下拉列表时补入选项，避免显示纯数字 ID */
    ensureTeacherOptions(ids, namesRaw) {
      const existIds = new Set(this.teacherList.map(u => String(u.Id)));
      const names = String(namesRaw || '').split(/[|/,，、]/).map(s => s.trim()).filter(Boolean);
      ids.forEach((id, idx) => {
        const sid = String(id);
        if (!existIds.has(sid)) {
          this.teacherList.push({
            Id: sid,
            TeacherName: names[idx] || names[0] || `教职工(${sid})`
          });
          existIds.add(sid);
        }
      });
    },

    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = item.search;
      } else {
        this.filters = { key: item.search };
      }
      this[item.Func].apply(this, item);
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) return;
      if (row) this.selectCurrentRow(row);
    },

    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(val, true);
        });
      }
    },

    handleAdd() {
      this.isEdit = false;
      this.dialogTitle = '新增故障类型';
      this.form = {
        Id: 0,
        DepartmentId: this.DepartmentId || 0,
        Name: '',
        Code: '',
        Sort: 1,
        IsDefault: false,
        RepairerTeacherIdList: []
      };
      if (this.DepartmentId && this.teacherList.length === 0) {
        this.loadTeachers(this.DepartmentId);
      }
      this.dialogVisible = true;
    },

    handleEdit() {
      if (!this.currentRow) {
        this.$message({ message: '请先选择要编辑的记录', type: 'warning' });
        return;
      }
      const row = this.currentRow;
      this.isEdit = true;
      this.dialogTitle = '编辑故障类型';
      const repairerIds = this.parseIdList(row.RepairerTeacherIds);
      const openEditDialog = () => {
        this.ensureTeacherOptions(repairerIds, row.RepairerTeacherNames);
        this.form = {
          Id: row.Id,
          DepartmentId: row.DepartmentId,
          Name: row.Name,
          Code: row.Code || '',
          Sort: row.Sort || 1,
          IsDefault: row.IsDefault,
          RepairerTeacherIdList: repairerIds.map(id => String(id))
        };
        this.dialogVisible = true;
      };
      if (row.DepartmentId) {
        this.loadTeachers(row.DepartmentId).then(openEditDialog).catch(() => {
          this.$message.error('加载维修师傅列表失败');
        });
      } else {
        openEditDialog();
      }
    },

    handleDel() {
      if (!this.currentRow) {
        this.$message({ message: '请先选择要删除的记录', type: 'warning' });
        return;
      }
      this.$confirm(`确认删除故障类型「${this.currentRow.Name}」？`, '提示', { type: 'warning' }).then(async () => {
        const res = await deleteRepairFaultType(this.currentRow.Id);
        if (res.data.success) {
          this.$message({ message: '删除成功', type: 'success' });
          this.currentRow = null;
          this.handleQuery();
        } else {
          this.$message({ message: res.data.msg || '删除失败', type: 'error' });
        }
      }).catch(() => {});
    },

    handleInitDefaults() {
      if (!this.DepartmentId) {
        this.$message({ message: '请先选择学校/部门', type: 'warning' });
        return;
      }
      this.$confirm('将为当前部门初始化「电教、水电、其他」三种默认故障类型，已有数据将跳过。确认？', '提示', { type: 'info' })
        .then(async () => {
          const res = await initRepairFaultTypeDefaults(this.DepartmentId);
          if (res.data.success) {
            this.$message({ message: '初始化成功', type: 'success' });
            this.handleQuery();
          } else {
            this.$message({ message: res.data.msg || '操作失败', type: 'error' });
          }
        }).catch(() => {});
    },

    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitLoading = true;
        const payload = {
          ...this.form,
          RepairerTeacherIdList: (this.form.RepairerTeacherIdList || []).map(id => String(id))
        };
        if (!this.isEdit) {
          delete payload.Code;
        }
        const action = this.isEdit ? editRepairFaultType : addRepairFaultType;
        action(payload).then(res => {
          this.submitLoading = false;
          if (res.data.success) {
            this.$message({ message: this.isEdit ? '修改成功' : '新增成功', type: 'success' });
            this.dialogVisible = false;
            this.handleQuery();
          } else {
            this.$message({ message: res.data.msg || '操作失败', type: 'error' });
          }
        }).catch(() => { this.submitLoading = false; });
      });
    },

    onNameInput() {
      if (this.isEdit) return;
      this.form.Code = this.previewCodeFromName(this.form.Name);
    },

    previewCodeFromName(name) {
      const n = (name || '').trim();
      if (!n) return '';
      const known = { '电教': 'electrical', '水电': 'plumbing', '其他': 'other' };
      if (known[n]) return known[n];
      if (/^[a-zA-Z0-9_\-\s]+$/.test(n)) {
        return n.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      }
      return '保存后自动生成';
    }
  },

  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>
